import API from '@/lib/API.js'
import comun from './comun.js'
const provincias = {
  namespaced: true,
  state: {
    Lista: [],
    Seleccionado: undefined,
  },
  mutations: {
    init(state) {
      state.Seleccionado = undefined
  },
    set(state, payload) {
      state.Lista = payload;
    }
  },
  actions: {
    async set({
      commit,
      getters
    }) {
      let entidades = getters.getProvincias();
      if (entidades.length === 0) {
        commit("comun/cargando")
        let data = await API.Provincias.traerTodos();
        commit("set", data)
        commit("comun/fincarga")
      }
    },
  },
  getters: {
    getProvincias: state => () => {
      return state.Lista;
    }
  },
  modules: {
    comun,
  }

}
export default provincias;